export class MetaData {
    constructor(
      public totalResults: number,
      public resultsPerPage: number,
      public nextPageId: string
    ) { }
  }
  